import { Component, forwardRef, Input, OnDestroy, OnInit } from '@angular/core';
import { ControlValueAccessor, FormBuilder, UntypedFormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatRadioChange } from '@angular/material/radio';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {AppState } from 'src/app/core/models/app-state.models';
/* import { ConsultationAnsOption } from 'src/app/core/models/consultations.models'; */
import { sessionSelectors } from 'src/app/store/selectors';

@Component({
    selector: 'doc-form-radio',
    templateUrl: 'radio.component.html',
    styleUrls: ['radio.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DocRadioComponent),
            multi: true
        }
    ]
})

export class DocRadioComponent implements OnInit, OnDestroy, ControlValueAccessor {
    private onDestroyed$ = new Subject();
    @Input() label = '';
   /*  @Input() options: RadioOption[] | ConsultationAnsOption[] = []; */
    @Input() parentForm: UntypedFormGroup;
    @Input() controlName: string;
    @Input() boldLabel = false;

   

    value: string = '';
    changed = (value: any) => { };
    touched = () => { };
    disabled: boolean;

    constructor(
        private store: Store<AppState>
    ) {
        
    }

    ngOnInit() { }

   /*  getValue(option: RadioOption | ConsultationAnsOption) {
        if (option.hasOwnProperty('value')) {
            return option['value'];
        } else if (option.hasOwnProperty(this.lang)) {
            return option[this.lang]
        } else {
            return ''
        }
    } */

   /*  getKey(option: RadioOption | ConsultationAnsOption) {
        if (option.hasOwnProperty('key')) {
            return option['key'];
        } else if (option.hasOwnProperty(this.lang)) {
            return option[this.lang]
        } else {
            return ''
        }
    }
 */
    /* isChecked(option) {
        if (this.getValue(option) === this.value) {
            return true;
        }
    } */

    writeValue(value: any): void {
        this.value = value ? value : '';
    }
    registerOnChange(fn: any): void {
        this.changed = fn;
    }
    registerOnTouched(fn: any): void {
        this.touched = fn;
    }
    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    selectionChanged(e: MatRadioChange) {
        this.changed(e.value);
        this.touched();
    }

    ngOnDestroy() {
        this.onDestroyed$.next();
        this.onDestroyed$.complete();
    }
}

interface RadioOption {
    key: string,
    value: string
};